"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendLoginLandingEvent = void 0;
var _1 = require(".");
/**
 * Sends an event that a user login
 * Event name: "web:landing:::login"
 */
var sendLoginLandingEvent = function (platform) {
    (0, _1.sendEvent)("landing", null, null, "login", { platform: platform });
};
exports.sendLoginLandingEvent = sendLoginLandingEvent;
